import { render } from "./AgentsInfoBar.vue?vue&type=template&id=29d39456&scoped=true&ts=true"
import script from "./AgentsInfoBar.vue?vue&type=script&lang=ts"
export * from "./AgentsInfoBar.vue?vue&type=script&lang=ts"

import "./AgentsInfoBar.vue?vue&type=style&index=0&id=29d39456&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d39456"]])

export default __exports__